import React from 'react';
import MaterialIcon from 'material-icons-react';
import { UncontrolledTooltip } from 'reactstrap';

const InformationTooltip = props => {
    return (
        <div id={`icon_${props.targetId}`} style={{padding: '5px'}}>
            <MaterialIcon icon="warning" color="#ffc107" size={25} />
            <UncontrolledTooltip placement={props.placement} target={`icon_${props.targetId}`} >
                {props.message}
            </UncontrolledTooltip>
        </div>
    );
}

InformationTooltip.defaultProps = {
    message: "Message",
    placement: "top",
    targetId: '' //targetId must be Unique, otherwise it will not work
}

export default InformationTooltip;


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/InformationTooltip.js